import { IBuildingOption } from "../types/proposta";

export function formatBuildingLabel(
  building: Pick<IBuildingOption, "id" | "id_display" | "descricao">,
): string {
  const id = building.id_display ?? building.id;
  const descricao = building.descricao?.trim() || "Sem descrição";
  return `${id} - ${descricao}`;
}

export function formatBuildingLabelFromApi(data: {
  id?: number | string;
  id_display?: number | string;
  descricao?: string;
  titulo?: string;
  sobre?: string;
}): string {
  const id = data.id_display ?? data.id ?? "";
  const descricao =
    data.descricao?.trim() || data.titulo?.trim() || data.sobre?.trim() || "";

  if (!id && !descricao) return "";
  if (!id) return descricao;
  if (!descricao) return String(id);
  return `${id} - ${descricao}`;
}
